import React from 'react'
import PropTypes from 'prop-types'


import IconExpandLess from '@material-ui/icons/ExpandLess'
import IconExpandMore from '@material-ui/icons/ExpandMore'
import { Menu, } from '@material-ui/core'
import { useStyles } from "./appMenuStyples";
import AppMenuItemComponent from './AppMenuItemComponent'

import { isAuthorized } from '../../utils/auth/authConfig'


// React runtime PropTypes
export const AppMenuItemPropTypes = {
    name: PropTypes.string.isRequired,
    path: PropTypes.string,
    close: PropTypes.func,
    items: PropTypes.array,
    showInMenu: PropTypes.bool,
    roles: PropTypes.any
}


// TypeScript compile-time props type, infered from propTypes
// https://dev.to/busypeoples/notes-on-typescript-inferring-react-proptypes-1g88

type AppMenuItemPropTypesType = PropTypes.InferProps<typeof AppMenuItemPropTypes>
type AppMenuItemPropsWithoutItems = Omit<AppMenuItemPropTypesType, 'items'>

// Improve child items declaration
export type AppMenuItemProps = AppMenuItemPropsWithoutItems & {
    items?: AppMenuItemProps[]
}

const AppMenuItem: React.FC<AppMenuItemProps> = props => {

    const { name, path, close, items = [] } = props
    const classes = useStyles()
    const isExpandable = items && items.length > 0
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const [open, setOpen] = React.useState(false);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setOpen(!open);
    };

    const MenuItemRoot = (
        <AppMenuItemComponent link={path}
            expandable={isExpandable}
            onClick={close ? close : handleClick}
            className={classes.menuButton}>
            {name}
            {isExpandable && !open && <IconExpandMore />}
            {isExpandable && open && <IconExpandLess />}
        </AppMenuItemComponent>
    )



    const MenuItemChildren = isExpandable ? (
        <Menu open={open}
            anchorEl={anchorEl}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            keepMounted
            className={classes.subMenu}
            onClose={handleClick}>
            {items.map((item) => (
                item.showInMenu && isAuthorized(item.roles) ? <AppMenuItem {...item} close={handleClick} key={item.name} /> : ""
            ))}
        </Menu>
    ) : null

    return (
        <>
            {MenuItemRoot}
            {MenuItemChildren}
        </>
    )
}

AppMenuItem.propTypes = AppMenuItemPropTypes

export default AppMenuItem
